export default __webpack_public_path__ + "static/media/logo-t.b5a1d53c.png";